const layoutMap = {
  light: () => import('libs/components-theme-picker/legacy/assets/light-layout.svg'),
  dark: () => import('libs/components-theme-picker/legacy/assets/dark-layout.svg'),
  system: () => import('libs/components-theme-picker/legacy/assets/system-layout.svg'),
};

export const resolveLayoutAsset = (name: 'light' | 'dark' | 'system'): Promise<string> =>
  layoutMap[name]().then(module => module.default);
